import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, ActivityIndicator } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import ListView from '../../../components/common/list-view';
import Text, { Small, Large } from '../../../components/common/text';
import { H1 } from '@dbk/ui-text';
import styles from './transaction-history.styles';
import TableRow from '../../../components/common/table-row';
import { Accordion, AccordionItem } from '@dbk/ui-accordion'
import StickyHeaderTablet from './sticky-header-tablet';
import StickyHeader from './sticky-header';
import { PALETTE, PAGE } from '../../../constants';
import CalendarModal from '../../../components/common/calendar-modal';
import DateSelectionBar from '../../../components/common/date-selection-bar';
import { ChangeIndicatedCurrency, ChangeIndicatedAbbreviatedNumber } from '../../../components/common/number';
import Pagination from '../../../components/common/pagination';
import format from 'date-fns/format';
import getPaginatedItems from '../../../utils/get-paginated-items';
import SimpleDate from '../../../components/common/date';
import { Tabs, Tab } from '@dbk/ui-tabs';
import { DatePicker } from '@dbk/ui-datepicker';
import moment from 'moment';
import LoadingCircle from '../../../components/common/loading/loading-circle';

var languageCode = 'en';

class TransactionHistory extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      timeline: 0,
      currentYear: new Date().getFullYear(),
      lastYear: new Date().getFullYear() - 1,
      fromDate: 'date',
      toDate: 'date',
      pageOffset: 0,
      activeItems: '',
      currentTab: 0,
      value: {
        from: moment(),
        to: moment(),
      }
    };

    this.onSelectTime = this.onSelectTime.bind(this);
    this.props.getTransactionDetails();
    this.returnTabletTransactionList = this.returnTabletTransactionList.bind(this);
    this.setPageOffset = this.setPageOffset.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { trans } = this.props;
    // watch values
    if (this.props.trans) {
      if ((trans.startDate != prevProps.trans.startDate) || (trans.endDate != prevProps.trans.endDate)) {
        this.setState({
          value: {
            from: moment(trans.startDate),
            to: moment(trans.endDate),
          },
        })
        this.props.getTransactionDetails();
      }
    }
  }

  handleOnChange = (range) => {
    this.setState({
      value: {
        ...this.state.value,
        ...range
      }
    })
  }

  onApply = () => {
    this.props.onApply(this.state.value.from.format('YYYY-MM-DD'), this.state.value.to.format('YYYY-MM-DD'));
  }

  setPageOffset(newOffset) {
    this.setState({ pageOffset: newOffset });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  onSelectTime(options) {
    this.setState({ timeline: options });
    this.setState({ pageOffset: 0 });
    if (this.state.currentTab != options) {
      switch (options) {
        case 0:
          this.props.setRange7Days();
          this.setState({ currentTab: 0 });
          break;
        case 1:
          this.props.setRange30Days();
          this.setState({ currentTab: 1 });
          break;
        case 2:
          this.props.setRange3Months();
          this.setState({ currentTab: 2 });
          break;
        case 3:
          this.props.setRangeYTD();
          this.props.trans.calendar.open();
          this.setState({ currentTab: 3 });
          break;
      }
    }
  }

  _renderHeader(row) {
    return (
      <View>
        <TableRow>
          <TableRow.Column align="left" >
            <Text>
              <SimpleDate value={row.tradeDate} />
            </Text>
          </TableRow.Column>
          <TableRow.Column align="left">
            <Text>
              {row.tranTypeDesc}
            </Text>
          </TableRow.Column>
          <TableRow.Column align="right">
            <Text style={styles.currencyText}>{row.ccyTrade}</Text>
            <Text align='right' style={{ color: '#fff' }}>
              <ChangeIndicatedAbbreviatedNumber
                renderProps={{ size: 'normal' }}
                value={parseFloat(row.netAmtTradeCcy)}
                maxDigits={7}
                renderExactAs="currency"
                onlyNegativeStyling
              />
            </Text>
          </TableRow.Column>
        </TableRow>
      </View>
    );
  }

  _renderContent(row) {
    const { i18n: { messages }, } = this.props;
    return (
      <View >
        <View style={styles.seperator}>
          <View style={styles.maginTableRow}>
            <TableRow>
              <TableRow.Column align="left">
                <Small>{messages['app.incomehistory.productContent']}</Small>
              </TableRow.Column>
              <TableRow.Column align="right">
                <Small>
                  <SimpleDate value={row.valueDate} />
                </Small>
              </TableRow.Column>
            </TableRow>
            <TableRow>
              <TableRow.Column align="left">
                <Small>
                  {messages['app.report.transactionHistory.quantity']}
                </Small>
              </TableRow.Column>
              <TableRow.Column align="right">
                <Small secondary>{row.qty.toLocaleString()}</Small>
              </TableRow.Column>
            </TableRow>
            <TableRow>
              <TableRow.Column align="left">
                <Small>
                  {messages['app.report.transactionHistory.purchasePrice']}
                </Small>
              </TableRow.Column>
              <TableRow.Column align="right">
                <Small secondary>{row.price}</Small>
              </TableRow.Column>
            </TableRow>
          </View>
        </View>
        <Small>{row.securityLongName}</Small>
      </View>
    );
  }

  handleChange = (activeItems) => {
    this.setState(
      {
        activeItems,
      },
      () => {
        if (this.props.rememberState && this.props.state.setExpandedItem) {
          const [rowId] = activeItems;
          if (rowId) {
            this.props.state.setExpandedItem(rowId);
          }
        }
      }
    );
  };

  renderRows(rows) {
    return rows.map((row, index) => {
      const isRowActive = this.state.activeItems.indexOf(index) !== -1;
      console.log('isRowActive', isRowActive)
      return (
        <AccordionItem
          itemKey={index}
          key={index}
          renderTitle={() => this._renderHeader(row, isRowActive)}
        >
          {this._renderContent(row)}
        </AccordionItem>
      )
    });
  }

  returnTabletTransactionList(asset) {
    const { tradeDate, tranTypeDesc, securityLongName, ccyTrade, valueDate, qty, netAmtTradeCcy } = asset;
    return (
      <div className="row">
        <div className="columns small-2 medium-2 large-2">
          <Small ><SimpleDate value={tradeDate} /> </Small>
        </div>
        <div className="columns small-2 medium-2 large-2">
          <Small ><SimpleDate value={valueDate} /></Small>
        </div>
        <div className="columns small-2 medium-2 large-2">
          <Small >{tranTypeDesc}</Small>
        </div>
        <div className="columns small-3 medium-3 large-3">
          <Small >{securityLongName}</Small>
        </div>
        <div className="columns small-1 medium-1 large-1 text-align-right columnCustomWidth">
          <Small >{qty.toLocaleString()}</Small>
        </div>
        <div className="columns small-2 medium-2 large-2 text-align-right columnCustomWidth">
          <Small >
          {netAmtTradeCcy === null ? "-" :
              <ChangeIndicatedCurrency
                value={parseFloat(netAmtTradeCcy)}
                renderProps={{ size: 'small' }}
                currency={ccyTrade}
                onlyNegativeStyling />}
          </Small>
        </div>
      </div>
    );
  }

  render() {
    let stickyHeader = <StickyHeader />;
    const { screen, i18n: { messages } } = this.props;
    const { transactionHistoryList, isLoading, startDate, endDate } = this.props.trans;
    let transaction = [];
    let completeDate;

    if (this.props.auth.langCode && this.props.auth.langCode != null) {
      languageCode = this.props.auth.langCode.toLowerCase();
    }

    if (startDate == endDate) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.singleLanguage']} <SimpleDate month='long' value={format(startDate, 'DD MMMM YYYY')} /></div>;
    } else if (startDate != undefined && startDate.length != 0 && endDate != undefined && endDate.length != 0) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.multipleLanguage']} <SimpleDate month='long' value={format(startDate, 'DD MMMM YYYY')} /> {messages['app.common.to']} <SimpleDate month='long' value={format(endDate, 'DD MMMM YYYY')} /></div>;
    }

    if (transactionHistoryList != undefined && transactionHistoryList != null) {
      transaction = transactionHistoryList;
    }

    const { pageOffset } = this.state;
    const pageSize = PAGE.pageSize;
    const paginatedTransactions = getPaginatedItems(transaction, pageOffset, pageSize);

    {
      !screen.isSmall ? stickyHeader = <StickyHeaderTablet messages={messages} />
        : stickyHeader = <StickyHeader messages={messages} />
    }

    return (
      <div className="minHeight">
        <div className="row transactionHistoryRows">
          <div className="columns small-12 medium-12 large-12">
            <H1 secondary>
              {messages['app.common.pageTitle.transactionHistory']}
            </H1>
            <div className="module">
              <div className="columns small-centered medium-centered large-centered">
                <View style={styles.groupSelection}>
                  <Tabs
                    secondary
                    handleSelectedIndex={this.onSelectTime}
                    selectedIndex={this.state.timeline}
                    stretch
                  >
                    <Tab renderLabel={() => <Small>{messages['app.incomehistory.7days']}</Small>}></Tab>
                    <Tab renderLabel={() => <Small>{messages['app.report.transactionHistory.30days']}</Small>}></Tab>
                    <Tab renderLabel={() => <Small>{messages['app.report.transactionHistory.3months']}</Small>}></Tab>
                    <Tab renderLabel={() => <Small>{messages['app.maturities.overview.tabs.labels.custom']}</Small>}></Tab>
                  </Tabs>
                </View>
              </div>
              <div className="columns small-10 small-centered medium-12 medium-centered large-12 large-centered">
                <div className="row margin-top-10">
                  <div className="columns small-6 medium-7 large-9 ">
                    <DateSelectionBar text={completeDate} isEditable={false} />
                  </div>
                  <div className="columns small-6 medium-5 large-3">
                    {this.state.timeline == 3 && (
                      <DatePicker enableYearNavigation
                        enableRangeSelection
                        onChange={this.handleOnChange}
                        value={this.state.value}
                        startDate={moment().add(-2, 'year')}
                        endDate={moment()}
                        selectionStart={this.state.value.from}
                        selectionEnd={this.state.value.to}
                        onApply={this.onApply}
                      />
                    )}
                  </div>
                </div>
              </div>
              {stickyHeader}
              <View>
                {!screen.isSmall ?
                  <View>
                    {isLoading ?
                      <View>
                        <LoadingCircle />
                      </View>
                      :
                      <span>
                        {paginatedTransactions.length > 0 ?
                          <ListView
                            rows={paginatedTransactions}
                            testID="trans"
                            renderRow={(trans) => {
                              return (
                                <ListView.Row>
                                  {this.returnTabletTransactionList(trans)}
                                </ListView.Row>
                              );
                            }}
                          />
                          : <div className="text-center margin-top-20">
                            <Large> {messages['app.reports.noRecords']}</Large>
                          </div>
                        }
                      </span>
                    }
                  </View>
                  :
                  <span>
                    {isLoading ?
                      <View style={styles.loadingIndicator}>
                        <ActivityIndicator
                          animating
                          color={PALETTE.primaryText}
                          size="large"
                        />
                      </View>
                      :
                      <View style={styles.root}>
                        <View style={{ marginLeft: 5, marginRight: 5 }}>
                          {paginatedTransactions.length > 0 ?
                            <Accordion
                              testID="list"
                              activeItems={this.state.activeItems}
                              onChange={this.handleChange}
                            >
                              {this.renderRows(paginatedTransactions)}
                            </Accordion>
                            : <Large style={styles.empty}> {messages['app.reports.noRecords']} </Large>
                          }
                        </View>
                      </View>
                    }
                  </span>
                }

                <Pagination
                  pageOffset={pageOffset}
                  pageSize={pageSize}
                  totalRecords={transaction.length}
                  setPageOffset={this.setPageOffset}
                  style={{ marginVertical: 20 }} />

              </View>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TransactionHistory.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  trans: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getTransactionDetails: {
      $call: 'trans.getTransactionDetails'
    },
    trans: {
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      dateDisplay: true,
      transactionHistoryList: true,
      isLoading: true,
    },
    getStatementPdf: {
      $call: 'trans.getPdf'
    },
    setRange7Days: {
      $call: 'trans.setRange7Days'
    },
    setRange30Days: {
      $call: 'trans.setRange30Days'
    },
    setRange3Months: {
      $call: 'trans.setRange3Months'
    },
    setRangeYTD: {
      $call: 'trans.setRangeYTD'
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      },
    },
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    auth: {
      langCode: true,
    },
    onApply: {
      $call: 'trans.onCalendarDone'
    },
  },
}, ({ app, ...queries }) => ({
  ...queries,
  deviceInfo: app.global.deviceInfo,
}))(TransactionHistory);

export { TransactionHistory };